import { render, staticRenderFns } from "./MapaDepartamento.vue?vue&type=template&id=ee52fa7a&"
import script from "./MapaDepartamento.vue?vue&type=script&lang=js&"
export * from "./MapaDepartamento.vue?vue&type=script&lang=js&"
import style0 from "./MapaDepartamento.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports